import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Contact from "../../components/contactSection/contact";
import FAQ from "../../components/faq/faq";
import HeroSection from "../../components/heroSection/hero";
import BgImage from "../../images/faq/bg-image.png";
import { contactLink } from "../../common/routes";

function FaqPage() {
  const ContactText = "Not sure which domain is right for you";
  const ContactButtonText = "Talk to our counsellor";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <HeroSection heroBgImage={BgImage} text={"FAQ"} />
      <FAQ />
      <Contact text={ContactText} buttonText={ContactButtonText} url={contactLink} />
    </Box>
  );
}

export default FaqPage;
